import React, { useState } from 'react';
import { Row, Col } from 'antd';
import ConversationList from './components/conversation-list';
import ChatBox from './components/chat-box';
import './conversation.scss';

const Conversations = () => {
  const [selectedConversation, setSelectedConversation] = useState(null);

  const handleConversationClick = (item) => {
    setSelectedConversation(item);
  };

  return (
    <div className='conversation-wrapper'>
   

      <Row gutter={24}>
        <Col span={16}>
          <h2 className='page-title'>Chat History</h2>
          <ChatBox selectedConversation={selectedConversation} />
        </Col>
        <Col span={8}>
          <h2 className='page-title'>Select conversation</h2>
          <ConversationList handleClick={handleConversationClick} />
        </Col>
      </Row>
    </div>
  );
};

export default Conversations;
